import { BehaviorSubject, combineLatest, forkJoin, Observable } from 'rxjs';
import { SocieteModel } from './../../shared/models/simple-types/societe.model';
import { ArticleModel } from './../../shared/models/societe-linked/article.model';
import { CATEGORIEVALIDATORS } from './../../shared/constants/categorie-validators';
import { CategorieModel } from '../../shared/models/simple-types/categorie.model';
import { CA2VALIDATORS } from './../../shared/constants/ca1-ca2-validators';
import { Ca2Model } from './../../shared/models/societe-linked/ca2.model';
import { TypeCompModel } from '../../shared/models/simple-types/type-comp.model';
import { COMPVALIDATORS, TYPECOMPVALIDATORS } from './../../shared/constants/comp-validators';
import { CompModel } from './../../shared/models/societe-linked/comp.model';
import { CONDREGLVALIDATORS } from './../../shared/constants/cond-regl-validators';
import { CondReglModel } from './../../shared/models/simple-types/cond-regl.model';
import { SITEVALIDATORS } from './../../shared/constants/site-validators';
import { SiteModel } from 'src/app/shared/models/societe-linked/site.model';
import { MODEREGLVALIDATORS } from './../../shared/constants/mode-regl-validators';
import { TVAVALIDATORS } from './../../shared/constants/tva-validators';
import { TvaModel } from './../../shared/models/simple-types/tva.model';
import { CGCHARGEVALIDATORS } from './../../shared/constants/cg-charge-validators';
import { CgChargeModel } from '../../shared/models/simple-types/cg-charge.model';
import { NAVALIDATORS } from './../../shared/constants/na-validators';
import { NaModel } from 'src/app/shared/models/simple-types/na.model';
import { CA1VALIDATORS, SEUILVALIDATORS } from '../../shared/constants/ca1-ca2-validators';
import { Ca1Model } from './../../shared/models/societe-linked/ca1.model';
import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { FormInfo, SOCIETEVALIDATORS } from 'src/app/shared/constants/societe-validators';
import { SeuilModel } from 'src/app/shared/models/simple-types/seuil.model';
import { ModeReglModel } from 'src/app/shared/models/simple-types/modeRegl.model';
import { ARTICLEVALIDATORS } from 'src/app/shared/constants/article-validators';
import { debounceTime, distinctUntilChanged, filter, switchMap, tap } from 'rxjs/operators';
import { CgChargeService } from 'src/app/shared/services/simple/cg-charge.service';
import { NaService } from 'src/app/shared/services/simple/na.service';
import { StateService } from 'src/app/shared/services/state.service';
import { TvaService } from 'src/app/shared/services/simple/tva.service';
import { CategorieService } from 'src/app/shared/services/simple/categorie.service';
import { SiteService } from 'src/app/shared/services/societe-linked/site.service';
import { ArticleService } from 'src/app/shared/services/societe-linked/article.service';
import { ActiviteModel } from 'src/app/shared/models/simple-types/activite.model';
import { ACTIVITEVALIDATORS } from 'src/app/shared/constants/activite-validators';
import { SsFamilleModel } from 'src/app/shared/models/simple-types/ss-famille.model';
import { FamilleModel } from 'src/app/shared/models/simple-types/famille.model';
import { FAMILLEVALIDATORS, SSFAMILLEVALIDATORS } from 'src/app/shared/constants/famille-validators';
import { PeriodeSageModel } from 'src/app/shared/models/societe-linked/periode-sage.model';
import { PERIODEVALIDATORS } from 'src/app/shared/constants/periode-validators';
import { getMonth } from 'src/app/shared/constants/month';

export class DetailReferentielInfos {
  categories: CategorieModel[] = [];
  articles: ArticleModel[] = [];
  cgCharges: CgChargeModel[] = [];
  nas: NaModel[] = [];
  tvas: TvaModel[] = [];
  sites: SiteModel[] = [];
}

@Injectable()
export class GestionReferentielComponentService {
  private defaultDetailReferentielInfosSource: BehaviorSubject<DetailReferentielInfos> = new BehaviorSubject(new DetailReferentielInfos);
  constructor(protected naService: NaService,
    protected cgchargeService: CgChargeService,
    protected state: StateService,
    protected tvaService: TvaService,
    protected categorieService: CategorieService,
    protected siteService: SiteService,
    protected articleSercice: ArticleService) {
  }

  loadDetailReferentiel(): Observable<DetailReferentielInfos> {
    const infos = new DetailReferentielInfos();
    this.defaultDetailReferentielInfosSource.next(infos);
    this.state.society.pipe(filter(d => d !== null), debounceTime(300), switchMap(soc => {
      return forkJoin<any>([
        this.naService.getAll().pipe(tap(objs => infos.nas = objs)),
        this.cgchargeService.getAll().pipe(tap(objs => infos.cgCharges = objs)),
        this.tvaService.getAll().pipe(tap(objs => infos.tvas = objs)),
        //this.categorieService.getFromSociete(soc.id).pipe(tap(objs => infos.categories = objs)), A MODIFIER !!!!
        this.siteService.getFromSociete(soc.id).pipe(tap(objs => infos.sites = objs)),
        this.articleSercice.getFromSociete(soc.id).pipe(tap(objs => infos))
      ]);
    })).subscribe(_ => this.defaultDetailReferentielInfosSource.next(infos));

    return this.defaultDetailReferentielInfosSource;
  }

  getVisualizeSocieteFormGroup(societe: SocieteModel): UntypedFormGroup {
    const form = this.getForm(societe, SOCIETEVALIDATORS.VISUALIZE);
    return form;
  }

  getEditSocieteFormGroup(societe: SocieteModel): UntypedFormGroup {
    const form = this.getSocieteForm(societe, SOCIETEVALIDATORS.EDIT);
    return form;
  }

  getEditCa1FormGroup(ca1: Ca1Model): UntypedFormGroup {
    const form = this.getForm(ca1, CA1VALIDATORS.EDIT);
    return form;
  }

  getEditCa2FormGroup(ca2: Ca2Model): UntypedFormGroup {
    const form = this.getForm(ca2, CA2VALIDATORS.EDIT);
    this.getCa2FormEvent(form);
    return form;
  }

  getEditNaFormGroup(na: NaModel): UntypedFormGroup {
    const form = this.getForm(na, NAVALIDATORS.EDIT);
    this.getNaFormEvent(form);
    return form;
  }

  getEditCgChargeFormGroup(cg: CgChargeModel): UntypedFormGroup {
    const form = this.getForm(cg, CGCHARGEVALIDATORS.EDIT);
    return form;
  }

  getEditTvaFormGroup(tva: TvaModel): UntypedFormGroup {
    const form = this.getForm(tva, TVAVALIDATORS.EDIT);
    this.getTvaFormEvent(form);
    return form;
  }

  getEditSsFamilleFormGroup(ssFamille: SsFamilleModel): UntypedFormGroup {
    const form = this.getForm(ssFamille, SSFAMILLEVALIDATORS.EDIT);
    return form;
  }

  getEditFamilleFormGroup(famille: FamilleModel): UntypedFormGroup {
    const form = this.getForm(famille, FAMILLEVALIDATORS.EDIT);
    return form;
  }

  getCreateSsFamilleFormGroup(): UntypedFormGroup {
    const ssFamille = new SsFamilleModel();
    const form = this.getForm(ssFamille, SSFAMILLEVALIDATORS.CREATE);
    return form;
  }

  getCreateFamilleFormGroup(): UntypedFormGroup {
    const famille = new FamilleModel();
    const form = this.getForm(famille, FAMILLEVALIDATORS.CREATE);
    return form;
  }

  private getTvaFormEvent(form: UntypedFormGroup): void {
    if (form.get('autoIntra').value) {
      form.get('compteFact2').setValidators(Validators.required);
      form.get('compteCompta2').setValidators(Validators.required);
      form.get('compteFact2').enable();
      form.get('compteCompta2').enable();
    } else {
      form.get('compteFact2').setValue('');
      form.get('compteCompta2').setValue('');
      form.get('compteFact2').disable();
      form.get('compteCompta2').disable();
    }
    form.updateValueAndValidity();
    form.get('autoIntra').valueChanges
      .subscribe(tvaAutoLiquide => {
        if (tvaAutoLiquide) {
          form.get('compteFact2').setValidators(Validators.required);
          form.get('compteCompta2').setValidators(Validators.required);
          form.get('compteFact2').enable();
          form.get('compteCompta2').enable();
        } else {
          form.get('compteFact2').setValue('');
          form.get('compteCompta2').setValue('');
          form.get('compteFact2').disable();
          form.get('compteCompta2').disable();
        }
        form.updateValueAndValidity();
      });
    }

  private getCa2FormEvent(form: UntypedFormGroup): void {
    form.get('code').valueChanges
    //.pipe(distinctUntilChanged())     
      .subscribe(code => {
        // Les codes CA2 ne peuvent contenir d’espace (supprimer automatiquement)
        form.get('code').patchValue( code.replaceAll(' ', ''), {emitEvent: false} );
      });
  }


  private getNaFormEvent(form: UntypedFormGroup): void {
    if (form.get('analyt2').value) {
      form.get('typeComp').enable();
    } else {
      form.get('typeComp').setValue(null);
      form.get('typeComp').disable();
    }
    form.get('analyt2').valueChanges
      .subscribe(tvaAutoLiquide => {
        if (tvaAutoLiquide) {
          form.get('typeComp').enable();
        } else {
          form.get('typeComp').setValue(null);
          form.get('typeComp').disable();
        }
        form.updateValueAndValidity();
      });
  }

  private getArticleEventForm(form: UntypedFormGroup) {
    let oldNaCode = '';
    combineLatest([
      form.get('codeNa').valueChanges,
      form.get('libelleNa').valueChanges,
      this.defaultDetailReferentielInfosSource])
      .pipe(
        filter(([code, libelle, detail]) => code && libelle && detail && detail.nas.length !== 0 && detail.cgCharges.length !== 0 && oldNaCode !== code)
      )
      .subscribe(([code, libelle, detail]) => {
        var na = detail.nas.find(obj => obj.code === code);
        var cgcharge = detail.cgCharges.find(obj => obj.code === na.cgCharge);
        form.get('codeCg').setValue(cgcharge.code);
        form.get('libelleCg').setValue(cgcharge.libelle);
      });
    
    var oldCodeCategorie = '';
    combineLatest([
      form.get('codeCategorie').valueChanges,
      form.get('libelleCategorie').valueChanges,
      this.defaultDetailReferentielInfosSource])
      .pipe(
        filter(([code, libelle, detail]) => code && libelle && detail && detail.nas.length !== 0 && detail.cgCharges.length !== 0 && oldCodeCategorie !== code)
      )
      .subscribe(([code, libelle, detail]) => {
        var categorie = detail.categories.find(obj => obj.code === code);
        /*var na = detail.nas.find(obj => obj.code === categorie.codeNa);
        form.get('codeNa').setValue(na.code);
        form.get('libelleNa').setValue(na.libelle);*/
        // A MODIFIER !!!!
        if(categorie.codeTva && categorie.codeTva !== '') {
          var tva = detail.tvas.find(obj => obj.code === categorie.codeTva);
          form.get('codeTva').setValue(tva.code);
          form.get('libelleTva').setValue(tva.libelle);
        }
      });
  } 

  private getPeriodeFormEvent(form: UntypedFormGroup, suivant: Date, precedent: Date): void {
    if(form.get('statut').value === "Clos"){
      form.get('date').disable();
      form.updateValueAndValidity();
    }
    form.get('date').valueChanges
      .subscribe(date => {
        form.get('date').setValidators(dateValidator(form, suivant, precedent));
        form.updateValueAndValidity();
      });
  }

  private getSeuilEventForm(form: UntypedFormGroup): void {
    form.get('seuil1').valueChanges
      .subscribe(seuil => {
        form.controls.seuil2.setValidators([Validators.min(seuil),Validators.required]);
        form.updateValueAndValidity({ onlySelf: false, emitEvent: false });
        form.markAllAsTouched();
      });
      form.get('seuil2').valueChanges
      .subscribe(seuil => {
        form.controls.seuil3.setValidators([Validators.min(seuil),Validators.required]);
        form.controls.seuil1.setValidators([Validators.max(seuil),Validators.required]);
        form.controls.seuil3.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        form.controls.seuil1.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        form.markAllAsTouched();
      });
      form.get('seuil3').valueChanges
      .subscribe(seuil => {
        form.controls.seuil4.setValidators([Validators.min(seuil),Validators.required]);
        form.controls.seuil2.setValidators([Validators.max(seuil),Validators.required]);

        form.controls.seuil4.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        form.controls.seuil2.updateValueAndValidity({ onlySelf: true, emitEvent: false });
      });
      form.get('seuil4').valueChanges
      .subscribe(seuil => {
        form.controls.seuil3.setValidators([Validators.max(seuil),Validators.required]);
        form.controls.seuil4.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        form.controls.seuil2.updateValueAndValidity({ onlySelf: true, emitEvent: false });
      });
      
      form.get('seuil1').updateValueAndValidity({ onlySelf: true, emitEvent: true });
      form.get('seuil2').updateValueAndValidity({ onlySelf: true, emitEvent: true });
      form.get('seuil3').updateValueAndValidity({ onlySelf: true, emitEvent: true });
      form.get('seuil4').updateValueAndValidity({ onlySelf: true, emitEvent: true });
  }

  getEditModeReglFormGroup(mode: ModeReglModel): UntypedFormGroup {
    const form = this.getForm(mode, MODEREGLVALIDATORS.EDIT);
    return form;
  }

  getEditCondReglFormGroup(cond: CondReglModel): UntypedFormGroup {
    const form = this.getForm(cond, CONDREGLVALIDATORS.EDIT);
    return form;
  }

  getEditSiteFormGroup(site: SiteModel): UntypedFormGroup {
    const form = this.getForm(site, SITEVALIDATORS.EDIT);
    return form;
  }

  getEditPeriodeFormGroup(periode: PeriodeSageModel, suivant: Date, precedent: Date): UntypedFormGroup {
    const form = this.getForm(periode, PERIODEVALIDATORS.EDIT);
    form.get('date').setValidators(dateValidator(form, suivant, precedent));
    form.updateValueAndValidity();
    this.getPeriodeFormEvent(form, suivant, precedent);
    return form;
  }

  getEditCategorieFormGroup(categorie: CategorieModel): UntypedFormGroup {
    const form = this.getForm(categorie, CATEGORIEVALIDATORS.EDIT);
    return form;
  }

  getEditArticleFormGroup(article: ArticleModel): UntypedFormGroup {
    const form = this.getForm(article, ARTICLEVALIDATORS.EDIT);
    this.getArticleEventForm(form);
    return form;
  }

  getEditCompFormGroup(comp: CompModel): UntypedFormGroup {
    const form = this.getForm(comp, COMPVALIDATORS.EDIT);
    return form;
  }

  getEditTypeCompFormGroup(typeComp: TypeCompModel): UntypedFormGroup {
    const form = this.getForm(typeComp, TYPECOMPVALIDATORS.EDIT);
    return form;
  }

  getEditActiviteFormGroup(activite: ActiviteModel): UntypedFormGroup {
    const form = this.getForm(activite, ACTIVITEVALIDATORS.EDIT);
    return form;
  }
  getSeuilFormGroup(seuil: SeuilModel): UntypedFormGroup {
    const form = this.getForm(seuil, SEUILVALIDATORS.CREATE);
    this.getSeuilEventForm(form);
    return form;
  }

  getCreateSocieteFormGroup(): UntypedFormGroup {
    const societe = new SocieteModel();
    societe.activite = new ActiviteModel();
    const form = this.getSocieteForm(societe, SOCIETEVALIDATORS.CREATE);
    return form;
  }

  getCreateCa1FormGroup(): UntypedFormGroup {
    const ca1 = new Ca1Model();
    const form = this.getForm(ca1, CA1VALIDATORS.CREATE);
    return form;
  }

  getCreateCa2FormGroup(): UntypedFormGroup {
    const ca2 = new Ca2Model();
    const form = this.getForm(ca2, CA2VALIDATORS.CREATE);
    this.getCa2FormEvent(form);
    return form;
  }

  getCreateCgChargeFormGroup(): UntypedFormGroup {
    const cg = new CgChargeModel();
    const form = this.getForm(cg, CGCHARGEVALIDATORS.CREATE);
    return form;
  }

  getCreateTvaFormGroup(): UntypedFormGroup {
    const tva = new TvaModel();
    const form = this.getForm(tva, TVAVALIDATORS.CREATE);
    this.getTvaFormEvent(form);
    return form;
  }

  getCreateSiteFormGroup(): UntypedFormGroup {
    const site = new SiteModel();
    const form = this.getForm(site, SITEVALIDATORS.CREATE);
    return form;
  }

  getCreateCategorieFormGroup(): UntypedFormGroup {
    const categorie = new CategorieModel();
    const form = this.getForm(categorie, CATEGORIEVALIDATORS.CREATE);
    return form;
  }

  getCreateModeReglFormGroup(): UntypedFormGroup {
    const mode = new ModeReglModel();
    const form = this.getForm(mode, MODEREGLVALIDATORS.CREATE);
    return form;
  }
  getCreateCondReglFormGroup(): UntypedFormGroup {
    const cond = new CondReglModel();
    const form = this.getForm(cond, CONDREGLVALIDATORS.CREATE);
    return form;
  }
  getCreateNaFormGroup(): UntypedFormGroup {
    const na = new NaModel();
    const form = this.getForm(na, NAVALIDATORS.CREATE);
    this.getNaFormEvent(form);
    return form;
  }

  getCreateArticleFormGroup(): UntypedFormGroup {
    const article = new ArticleModel();
    const form = this.getForm(article, ARTICLEVALIDATORS.CREATE);
    this.getArticleEventForm(form);
    return form;
  }

  getCreateCompFormGroup(): UntypedFormGroup {
    const comp = new CompModel();
    const form = this.getForm(comp, COMPVALIDATORS.CREATE);
    return form;
  }

  getCreateTypeCompFormGroup(): UntypedFormGroup {
    const typeComp = new TypeCompModel();
    const form = this.getForm(typeComp, TYPECOMPVALIDATORS.CREATE);
    return form;
  }

  getCreateActiviteFormGroup(): UntypedFormGroup {
    const activite = new ActiviteModel();
    const form = this.getForm(activite, ACTIVITEVALIDATORS.CREATE);
    return form;
  }

  getForm(entity: any, validators: Map<string, FormInfo>): UntypedFormGroup {
    const form = new UntypedFormGroup({});
    for (const [key, value] of validators.entries()) {
      // tslint:disable-next-line: max-line-length
      const control = new UntypedFormControl({ value: entity[key], disabled: validators.get(key).disabled }, validators.get(key).validators);
      form.addControl(key, control);
    }
    return form;
  }

  getSocieteForm(entity: any, validators: Map<string, FormInfo>): UntypedFormGroup {
    const form = new UntypedFormGroup({});
    for (const [key, value] of validators.entries()) {
      if (key !== 'activite') {
        const control = new UntypedFormControl({ value: entity[key], disabled: validators.get(key).disabled }, validators.get(key).validators);
        form.addControl(key, control);
      }
    }
    return form;
  }
}

 function dateValidator(form: UntypedFormGroup, suivant: Date, precedent: Date): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const today = new Date();
    if(!(control && control.value)) {
      // if there's no control or no value, that's ok
      return null;
    }
    //
    if(control.value <= new Date(precedent) && precedent !== null) {
      return {invalidDate: 'la date est inférieure à la date de clôture du mois précédent' } 
    } 
    if(control.value >= new Date(suivant) && suivant !== null) {
      return {invalidDate: 'la date est supérieure à la date de clôture du mois suivant' } 
    } 
    if(control.value < new Date(form.get('annee').value , 0, 1) ) {
      return {invalidDate: 'la date est inférieure au 1er janvier de l’année' } 
    }
    if(control.value < new Date(form.get('annee').value , form.get('mois').value - 1, 1) ) {
      return {invalidDate: 'la date est inférieure au 1er jour du mois de la periode de ' + getMonth(form.get('mois').value - 1) } 
    }
    if (control.value > new Date(form.get('annee').value + 1, 0, 10)){
      return {invalidDate: 'la date est supérieure au 10 janvier de l’année suivante' }
    }
    // return null if there's no errors
    return null;
    
  }
}
